<template>
  <UPageSection title="Locaties">
    <Locations class="h-[max(40rem,calc(100dvh_-_var(--ui-header-height)-8rem))] xl:h-[45rem] border rounded-sm overflow-hidden dark:border-neutral-800 border-neutral-200" />
  </UPageSection>
</template>
